module.exports = __webpack_public_path__ + "img/头图_中关村国际创新中心.27210bca.png";